import { useFormContext, useWatch } from 'react-hook-form';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { StoreTargetMapping, PropertyItem } from '../../../models/storetarget';

export default function ReviewStep() {
  const { control } = useFormContext();
  const propertyName = useWatch({
    name: 'propertyName',
  });

  const propertyItems: PropertyItem[] = useWatch({
    control,
    defaultValue: [],
    name: 'propertyItems',
  });

  const propertyType = useWatch({
    name: 'propertyType',
  });

  const StoreTargetMappings: StoreTargetMapping[] = useWatch({
    control,
    name: 'StoreTargetMappings',
  });

  const renderTable = (
    filteredData: StoreTargetMapping[],
    title: string,
    key: string | number,
  ) => {
    const tableHeadStyle = {
      width: '25%',
      textAlign: 'left',
      padding: '0 0 0 16px',
      height: '36px',
    };
    return (
      <div key={key} className="flex flex-col gap-3">
        <p>{title}</p>
        <div className="rounded border">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={tableHeadStyle}>Store</TableCell>
                <TableCell sx={tableHeadStyle}>Banner</TableCell>
                <TableCell sx={tableHeadStyle}>Location</TableCell>
                <TableCell sx={tableHeadStyle}>{propertyName}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => {
                const cellStyle = {
                  padding: '0 0 0 16px',
                  borderBottom:
                    index === filteredData.length - 1 ? 'none' : null,
                };
                return (
                  <TableRow key={row.storesId} sx={{ height: '36px' }}>
                    <TableCell sx={cellStyle}>{row.store}</TableCell>
                    <TableCell sx={cellStyle}>{row.bannerName}</TableCell>
                    <TableCell sx={cellStyle}>{row.location}</TableCell>
                    <TableCell sx={cellStyle}>{row.propertyValue}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-6 overflow-y-auto p-10">
      <h3 className="text-lg">Review Store Assignments</h3>

      {propertyItems?.map((item, index) => {
        const filteredData = StoreTargetMappings.filter(
          (mapping) => mapping.propertyValue === item.value,
        );
        return renderTable(filteredData, item.value, index);
      })}

      {propertyType === 'multi-select' &&
        renderTable(
          StoreTargetMappings.filter(
            (mapping) => mapping.propertyValue === 'Not Applicable',
          ),
          'Not Applicable',
          'not-applicable',
        )}
    </div>
  );
}
